import styled from 'styled-components'
import { PlatFormTypes } from '../../types/state'

interface ActiveProps {
	platform?: string
}

export const ContainerWrapper = styled.div<Pick<ActiveProps, 'platform'>>`
	padding: var(--pd-sm);
	color: var(--text-white-color);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-top: ${(props) =>
		props.platform === PlatFormTypes.MWEB ? '40px' : '0px'};
`

export const HeaderWrapper = styled.span`
	text-align: center;
	margin-top: var(--mg-md);
	margin-bottom: var(--mg-sm);
	font-weight: var(--fw-lg);
	font-size: var(--fs-xxl);
	text-transform: uppercase;
`

export const LenskartLogo = styled.img`
	margin-top: var(--mg-md);
	margin-bottom: var(--mg-sm);
	height: 75px;
`

export const EventLogo = styled.img`
	margin-top: var(--mg-md);
	margin-bottom: var(--mg-sm);
	height: 90px;
`

export const LogoWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-around;
`
